export default "__VITE_ASSET__85efe994__"